import React, { ChangeEvent, Component } from 'react';
import CustomTable from '../../../../custom/CustomTable';
import { RootState } from '../../../../../redux/store';
import { changeApiVariable } from '../../../../../redux/actions/ApiVariableActions';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import { ColumnProps } from 'primereact/column';
import { customConfirm } from '../../../../custom/CustomPopupConfirm';
import { ApiVariableParameter } from '../../../../../domain/remote/httpVariable/HttpVariableDomains';
import CustomInput from '../../../../custom/CustomInput';
import MessageUtil from '../../../../../util/MessageUtil';
import RoleHelper from '../../../../../RoleHelper';
import Icon from '../../../../../icons/Icon';
import EmptyComponent from '../../../../custom/empty-components/EmptyComponent';
import ComponentName from '../../../../../constant/ComponentName';
import { ApiVariableState } from '../../../../../redux/reducers/ApiVariableReducer';
import LanguageUtil from '../../../../../util/LanguageUtil';

class ApiHeadersListComponent extends Component<Props> {
  public render() {
    const {
      apiVariable: { apiVariable },
    } = this.props;
    if (Object.keys(apiVariable.headers).length <= 0) return <EmptyComponent createDisabled={true} type={ComponentName.ENRICHMENT}></EmptyComponent>;
    return (
      <div className={'overflow-y-hidden lg:!max-h-[calc(100vh-28.625rem)] 2xl:!max-h-[calc(100vh-30rem)] rounded-lg'}>
        <CustomTable columns={this.getColumns()} value={this.prepareHeaders()} />
      </div>
    );
  }

  private prepareHeaders = () => {
    const {
      apiVariable: { apiVariable },
    } = this.props;
    const keys = Object.keys(apiVariable.headers) as string[];
    const values = Object.values(apiVariable.headers) as string[];
    const headers = [];
    for (let i = 0; i < keys.length; i++) {
      headers.push({ key: keys[i], value: values[i] });
    }
    return headers;
  };

  private deleteApiHeader = (header: { key: string; value: string | number[] }) => {
    const {
      apiVariable: { apiVariable },
      changeApiVariable,
    } = this.props;
    delete apiVariable.headers[header.key];
    changeApiVariable(apiVariable);
  };

  private getColumns = (): ColumnProps[] => {
    return [
      {
        field: 'key',
        header: LanguageUtil.get({ id: 'pages.action.api.headers.table.key', defaultMessage: 'Key' }),
        className: 'min-w-[30%]',
        body: (headerParameter: any) => (
          <CustomInput
            inputType={'ghost'}
            type={'text'}
            disabled={!RoleHelper.canEdit('Action')}
            onChange={(e: ChangeEvent<HTMLInputElement>) => this.onChangeKey(e, headerParameter)}
            value={headerParameter.key}
            data-testid={`${ComponentName.ACTION}_header_key_input_${headerParameter.key}`}
          />
        ),
      },
      {
        field: 'value',
        header: LanguageUtil.get({ id: 'pages.action.api.headers.table.value', defaultMessage: 'Value' }),
        className: 'min-w-[30%]',
        body: (headerParameter: any) => (
          <CustomInput
            inputType={'ghost'}
            type={'text'}
            disabled={!RoleHelper.canEdit('Action')}
            onChange={(e: ChangeEvent<HTMLInputElement>) => this.onChangeValue(e, headerParameter)}
            value={headerParameter.value}
            data-testid={`${ComponentName.ACTION}_header_value_input_${headerParameter.key}`}
          />
        ),
      },
      {
        field: 'description',
        header: LanguageUtil.get({ id: 'pages.action.api.headers.table.description', defaultMessage: 'Description' }),
        className: 'min-w-[30%]',
      },
      {
        field: 'action',
        header: LanguageUtil.get({ id: 'pages.action.api.headers.table.action', defaultMessage: 'Action' }),
        className: 'max-w-[75px] 2xl:max-w-[100px]',
        alignHeader: 'center',
        sortable: false,
        body: (variableParameter: ApiVariableParameter) => (
          <div
            className={'flex items-center justify-center'}
            onClick={(e: any) => {
              e.stopPropagation();
              e.preventDefault();
              RoleHelper.canEdit('Action') &&
                customConfirm({
                  target: e.currentTarget,
                  accept: () => this.deleteApiHeader(variableParameter),
                  message: LanguageUtil.get({ id: 'messages.confirm.removeVariable', defaultMessage: 'Are you sure remove this variable ?' }),
                });
            }}
            data-testid={`${ComponentName.ACTION}_api_headers_list_${variableParameter.key}_remove_button`}
          >
            <Icon
              icon={'delete'}
              size={20}
              color={'primary'}
              className={'hover:text-primary text-primary hover:cursor-pointer flex items-center justify-center'}
            />
          </div>
        ),
      },
    ];
  };

  private onChangeKey = (e: ChangeEvent<HTMLInputElement>, headerParameter: any) => {
    const {
      apiVariable: { apiVariable },
      changeApiVariable,
    } = this.props;
  };

  private onChangeValue = (e: ChangeEvent<HTMLInputElement>, headerParameter: any) => {
    const {
      apiVariable: { apiVariable },
      changeApiVariable,
    } = this.props;

    !headerParameter.key.includes('Authorization')
      ? (apiVariable.headers[headerParameter.key] = e.target.value)
      : MessageUtil.warning({
          summary: 'Authorization',
          detail: (
            <div>
              You can only change "Authorization" header in <b>Authorization</b> tab
            </div>
          ),
        });
    changeApiVariable(apiVariable);
  };
}

interface Props extends ReduxProps {}

const mapStateToProps = (state: RootState) => ({
  apiVariable: state.apiVariable as ApiVariableState,
  isUpdate: state.apiVariable.isUpdate,
});

const mapDispatchToProps = { changeApiVariable };
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(ApiHeadersListComponent);
